// Onboarding-run observe endpoints (F2):
//   GET /api/v1/onboarding-runs?status&tenant_slug&site_slug  → RunOut[]
//   GET /api/v1/onboarding-runs/{id}                          → RunDetailOut
// Mirrors api/v1/onboarding_runs.py.

import { request, type ApiResponse } from "../client";
import type { RunCreateIn, RunDetailOut, RunListFilters, RunOut } from "../types/onboardingRun";

function queryString(filters?: RunListFilters): string {
  const p = new URLSearchParams();
  if (filters?.status) p.set("status", filters.status);
  if (filters?.tenant_slug) p.set("tenant_slug", filters.tenant_slug);
  if (filters?.site_slug) p.set("site_slug", filters.site_slug);
  const s = p.toString();
  return s ? `?${s}` : "";
}

export const onboardingRuns = {
  list: (filters?: RunListFilters): Promise<ApiResponse<RunOut[]>> =>
    request<RunOut[]>("GET", `/api/v1/onboarding-runs${queryString(filters)}`),
  get: (id: string): Promise<ApiResponse<RunDetailOut>> =>
    request<RunDetailOut>("GET", `/api/v1/onboarding-runs/${encodeURIComponent(id)}`),
  create: (body: RunCreateIn): Promise<ApiResponse<RunOut>> =>
    request<RunOut>("POST", "/api/v1/onboarding-runs", body),
  approve: (id: string): Promise<ApiResponse<RunOut>> =>
    request<RunOut>("POST", `/api/v1/onboarding-runs/${encodeURIComponent(id)}/approve`),
  queue: (id: string): Promise<ApiResponse<RunOut>> =>
    request<RunOut>("POST", `/api/v1/onboarding-runs/${encodeURIComponent(id)}/queue`),
  cancel: (id: string): Promise<ApiResponse<RunOut>> =>
    request<RunOut>("POST", `/api/v1/onboarding-runs/${encodeURIComponent(id)}/cancel`),
  reconcileRequeue: (id: string): Promise<ApiResponse<RunOut>> =>
    request<RunOut>("POST", `/api/v1/onboarding-runs/${encodeURIComponent(id)}/reconcile-requeue`),
};
